export const REC_ENGINE_ROUTES = {
  CAREERS: 'careers',
  JOBS: 'jobs',
  TRAINING: 'training',
  EXPERIENCE: 'experience',
  RATINGS: 'ratings',
};
